// extracted by mini-css-extract-plugin
export default {"section":"Layout_section__HO6HI","header":"Layout_header__vWpec","mainContent":"Layout_mainContent__o8xLM","footer":"Layout_footer__Wfml6"};